import "./ClarificationArticle.module.css";
import Header from "@/reusable_sections/Header";
import ArticleHeader from "./sections/ArticleHeader";
import InformationBlock from "./sections/InformationBlock";
import RecentPosts from "./sections/RecentPosts";
import Footer from "@/reusable_sections/Footer";
export default function ClarificationArticlePage() {
  return <div>
      <Header />
      <ArticleHeader />
      <InformationBlock />
      <RecentPosts />
      <Footer />
    </div>;
}